import { get } from 'lodash';
import { createSelector } from 'reselect';

export const commonStatePagingSelectors = (stateName) => {
  const root = (state) => get(state, `CommonState.${stateName}`);

  const getPageNumber = (state) => get(root(state), 'pageNumber', 1);
  const getPageSize = (state) => get(root(state), 'pageSize', 10);
  const getFilter = (state) => get(root(state), 'filter', []);
  const getSortColumn = (state) => get(root(state), 'sortColumn', []);
  const getPageResult = (state) => get(root(state), 'pageResult', []);
  const getData = (state) => get(getPageResult(state), 'Data', []);

  return {
    getLoading: (state) => get(root(state), 'loading'),
    getPageNumber: getPageNumber,
    getPageSize: getPageSize,
    getFilter: getFilter,
    getSortColumn: getSortColumn,
    getPaginationParameters: (state) => {
      return {
        PageNumber: getPageNumber(state),
        PageSize: getPageSize(state),
        Filter: getFilter(state),
        SortColumn: getSortColumn(state),
      };
    },

    getPageResult: (state) => get(root(state), 'pageResult', []),
    getHasNextPage: (state) => get(getPageResult(state), 'HasNextPage', true),
    getPages: (state) => get(getPageResult(state), 'Pages', 1),
    getData: (state) => get(getPageResult(state), 'Data', []),
    getDataLength: createSelector(getData, (data) => data.length),
    getTotal: createSelector(getPageResult, (result) => get(result, 'Total')),

    getSearchParameters: (state) => get(root(state), 'searchParameters', {}),
  };
};



// WEBPACK FOOTER //
// ./src/state/paging/selectors.js